import axios from 'axios'
import config from '../../constants/endpoints'
import getHeaders from '../helpers/headers'

const {
  endpoints: {
    marketing: { filters: url },
  },
} = config

/**
 * Get filters
 */
export const getFilters = () =>
  axios({
    url,
    method: 'get',
    headers: getHeaders(true),
  })
